<template>
  <footer class="foot">
    <div class="foot-in">
      <nav class="links" aria-label="About Thinking of U">
        <router-link to="/learn-more">Learn more</router-link>
        <router-link to="/faq">FAQ</router-link>
        <router-link to="/terms-of-service">Terms</router-link>
        <router-link to="/privacy-policy">Privacy</router-link>
        <router-link to="/contact-us">Contact</router-link>
        <a href="https://www.instagram.com/thinking.of.u.postcards/#" target="_blank" rel="noopener">Instagram</a>
      </nav>
      <span class="mark">Thinking of U</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
};
</script>

<style scoped>
.foot {
  background: var(--kraft);
  border-top: 1.5px solid var(--ink);
  font-family: var(--text);
  text-align: left;
  margin-top: auto;
}
.foot-in {
  max-width: var(--page);
  margin: 0 auto;
  padding: 22px var(--gut) 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px 28px;
  align-items: baseline;
  justify-content: space-between;
}
.links { display: flex; flex-wrap: wrap; gap: 8px 20px; }
.links a, .mark {
  font-family: var(--mono);
  font-size: .64rem;
  font-weight: 500;
  letter-spacing: .15em;
  text-transform: uppercase;
}
.links a { color: var(--ink-2); text-decoration: none; }
.links a:hover { color: var(--ink); text-decoration: underline; text-underline-offset: 4px; }
.links a:focus-visible { outline: 2.5px solid var(--red); outline-offset: 3px; }
.mark { color: var(--ink-3); }
</style>
